module.exports = "<div class=collector-bar> <div class=container-fluid> <div class=row> <div class=col-sm-12> <ink-login route=false type=\"'modal'\"></ink-login> <span class=logo-flat></span> <ink-state-switcher></ink-state-switcher> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./components/collector/collector-bar/collector-bar.template.html
// module id = ./components/collector/collector-bar/collector-bar.template.html
// module chunks = 0